const defaultWebsiteData = {
  // CUSTOMIZATION NOT PROOFING TEMPLATES
  /** @NOTE:  these two variables use for not proofing templates */
  /** @NOTE: for Embedded Gallery templates used variable `websiteDescriptionShow`
   * @LINK: /static/assets/js/components/Websites/configs/embeddedCustomizationConfig.js */
  notProofingTitleShow: true,
  notProofingDescriptionShow: true,

  // MAIN
  template: 'default',

  // CUSTOMIZATION PROOFING
  download: false,
  revisionsShow: false,
  commentShow: false,
  comment: false,
  titleShow: false,
  titleEditable: false,
  descriptionShow: false,
  descriptionEditable: false,
  customFieldsShow: false,
  searchShow: false,
  fileNameShow: false,
  flagShow: false,
  flag: false,
  ratingShow: false,
  rating: false,
  colorShow: false,
  color: false,
  tagsTreeShow: false,

  // CUSTOMIZATION WEBSITES
  overridedDisplayName: '', // this field overrides default user.fullname
  overridedTagname: '', // this field overrides default user.fullname
  logoUrl: '',
  avatarUrl: '',
  backgroundLoginPageUrl: '',
  thumbnailUrl: '',
  baseColor: '',
  fbLinkShow: true,
  twitterLinkShow: true,
  instagramLinkShow: true,
  phoneShow: true,
  emailShow: true,
  blogLinkShow: true,
  showFlagged: false,
  websiteFileNameShow: false,
  aboutShow: true,
  contactsShow: true,
  downloadLinkShow: true,
  downloadSingleFile: true,
  downloadAsOriginalOnly: false,
  sharingButtonsShow: '',
  expiresAt: '',

  // SEO
  googleAnalyticsIdentifier: '',
  customGalleryTitle: '',
  noFollow: true,
  noIndex: true,

  // Sort

  sortType: { type: 'updateTime', order: 'desc' },
  subcollectionsSortType: { type: 'alphabetical', order: 'desc' },

  // Security
  actionConsentEnable: false,
  actionConsentMessage: '',
  actionConsentTitle: '',
  visitingConsentEnable: false,
  visitingConsentMessage: '',
  visitingConsentTitle: '',

  emailEventTypes: [],
  emails: [],
  keywordsEditable: false,
  keywordsShow: false,
  theme: 'dark',
  useGdPdfViewer: null,
};

export default defaultWebsiteData;
